module.exports = __webpack_public_path__ + "static/media/yellowmachine--background.cbcf3ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/yellowmachine/yellowmachine--background.jpg
// module id = 172
// module chunks = 0